import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { PeriodoData } from 'app/model/periodoData.dto';
import { DadosExcecoesService } from 'app/service/dados-excecoes/dados-excecoes.service';
import { RelatorioRecadastramentoService } from 'app/service/relatorio-recadastramento/relatorio.service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver';

@Component({
  selector: 'app-relatorio-plano-saude-recadastramento',
  templateUrl: './relatorio-plano-saude-recadastramento.component.html',
  styleUrls: ['./relatorio-plano-saude-recadastramento.component.sass']
})
export class RelatorioPlanoSaudeRecadastramentoComponent implements OnInit {

  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();

  form: FormGroup;
  anos: number[] = [];
  showDownloadButton: boolean = true;
  exececoesService: any;
  relatorioPlanoSaude: any;
  anoPesquisa: number = 0;
  tipoCampanhaPesquisa: number = 0;



  constructor(private toastrService: ToastrService,
              private formBuilder: FormBuilder,
              private relatorioService: RelatorioRecadastramentoService,
              private dadosExcecoesService: DadosExcecoesService,) { }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      dataInicio: [new Date('2023-08-02'), Validators.required],
      dataFim: [new Date('2023-09-01'), Validators.required],
    });

    this.tipoCampanha()
  }

  filtroDataFim = (data: Date | null): boolean => {
    const dataInicio = this.form.get('dataInicio').value as Date;
    return !data || data >= dataInicio;
  };

  checkDiffData() {
    if (this.form.value.dataFim < this.form.value.dataInicio && this.form.value.dataFim != '' && this.form.value.dataFim != null) {
      // this.existeGrafico = false;
      this.toastrService.warning("Data de inicio maior que data fim.")
      this.form.controls.dataFim.reset()
    }
  }

  periodoCampanha() {
    if (this.form.controls.ano.status == 'VALID') {
      this.relatorioService.periodoCampanho(this.form.value.ano).subscribe((periodoCampanha: any) => {
        this.preencherCamposData(periodoCampanha);
      },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  private getPeriodo(ano) {
    return this.relatorioService.periodoCampanho(ano);
  }


  private preencherCamposData(data: PeriodoData) {
    if (data?.dataInicio && data?.dataFim) {
      const dataInicio = moment(data.dataInicio).toDate();
      const dataFim = moment(data.dataFim).toDate();

      this.form.patchValue({
        dataInicio,
        dataFim
      });
    }
  }

  tipoCampanha() {
    this.getAnosDisponiveisCampanha().subscribe(
      (response) => {
        this.anos = response;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private getAnosDisponiveisCampanha(): Observable<any> {
    return this.relatorioService.anosCampanha();
  }


  filtrarRelatorio(){
    this.checkDiffData();

    if (this.form.valid) {
      const dataInicio = this.form.get('dataInicio').value;
      const dataFim = this.form.get('dataFim').value;

      const dadosParaEnviar = {
        dataInicio: new Date(dataInicio).toISOString().slice(0, 10),
        dataFim: new Date(dataFim).toISOString().slice(0, 10),
      };

      this.relatorioService.dadosRelatorioPlanoSaude(dadosParaEnviar).subscribe((dadosRelatorio: any) => {
        console.log(dadosRelatorio)
      //   if (!dadosRelatorio || dadosRelatorio === 0) {
      //     this.showDownloadButton = true

      //     return
      // }
      const relatorioPlanoSaude = dadosRelatorio.relatorioPlanoSaude;
      if (!dadosRelatorio || dadosRelatorio == 0) {
        this.showDownloadButton = true
        this.toastrService.warning('Não foram encontrados recadastramentos realizados neste período!')

      } else {
        this.showDownloadButton = false
        this.relatorioPlanoSaude = dadosRelatorio;
        this.downloadExcelRelatorioPlanoSaude();
      }


      //   .map(item => item); // Extrair as datas dos objetos filtrados
      // console.log(relatorioPlanoSaude);
      //   const relatoriosComData = relatorioPlanoSaude.map(objeto => objeto !== null);
      },
    (error) => {
      console.error(error);

    });
    }
  }


  async downloadExcelRelatorioPlanoSaude() {
    if (!this.relatorioPlanoSaude || this.relatorioPlanoSaude.length === 0) {
      return; // Não gera o relatório se não houver dados
    }
    this.toastrService.info('Baixando arquivo. Por favor, aguarde!');

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('RelatorioPlanoSaude');

    const titleFont = {
      name: 'Arial',
      size: 11,
      bold: true,
      color: { argb: 'FFFFFF' }
    };

    const boldContentFont = {
      name: 'Arial',
      size: 9,
      bold: true
    };

    const contentFont = {
      name: 'Arial',
      size: 9
    };

    // Crie os títulos das colunas

    const headerRow = worksheet.addRow(['Matrícula', 'Nome do Servidor', 'Lotação', 'Descrição do Plano Atual', 'Data de Aquisição', 'Plano do Auxílio Saúde', 'Data de Início Auxílio Saúde']);
    headerRow.eachCell(cell => {
      cell.font = titleFont;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2187E5' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    // Adicione os dados
    this.relatorioPlanoSaude.forEach(item => {
      const row = worksheet.addRow([
        item.matricula,
        item.nome,
        item.lotacao,
        item.planoSaude,
        item.dataAquisicaoPlanoSaude,
        item.planoAuxilioSaude,
        item.dataAquisicaoAuxilioSaude
      ]);
      row.eachCell(cell => {
        cell.font = contentFont;
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });

    // Pule uma linha antes de adicionar os totais
    worksheet.addRow([]);

    // Ajuste a largura das colunas
    worksheet.columns.forEach(column => {
      column.width = 50; // Ajuste o valor conforme necessário
    });

    // Crie um Blob do arquivo Excel
    const blob = await workbook.xlsx.writeBuffer();

    // Inicie o download do arquivo
    const filename = 'relatorio_plano_saude.xlsx';
    fs.saveAs(new Blob([blob]), filename);
    this.toastrService.clear()
    this.toastrService.success('Arquivo baixado!');

  }

}
